/* eslint-disable @nx/enforce-module-boundaries */
import { ResultStream } from '@causality/core';
import { SelfCheckout } from '@formunauts/self-checkout/domain';

export abstract class SelfCheckoutRepository {
  abstract getAuthenticationForm(
    hash: SelfCheckout.Hash,
  ): ResultStream.ResultStream<
    SelfCheckout.AuthenticationForm,
    SelfCheckout.SelfCheckoutError
  >;

  abstract authenticate(
    payload: SelfCheckout.AuthenticationData,
  ): ResultStream.ResultStream<
    SelfCheckout.SelfCheckoutForm,
    SelfCheckout.SelfCheckoutError
  >;
  abstract checkoutDefault(
    payload: SelfCheckout.PreparedSelfCheckoutFormPayload,
  ): ResultStream.ResultStream<
    SelfCheckout.SelfCheckoutResponseDefault,
    SelfCheckout.SelfCheckoutError
  >;

  abstract checkoutTamaro(
    payload: SelfCheckout.PreparedSelfCheckoutFormPayload,
  ): ResultStream.ResultStream<
    SelfCheckout.SelfCheckoutResponseTamaro,
    SelfCheckout.SelfCheckoutError
  >;

  abstract getUnsubscribeForm(
    hash: SelfCheckout.Hash,
  ): ResultStream.ResultStream<
    SelfCheckout.UnsubscribeForm,
    SelfCheckout.SelfCheckoutError
  >;
  abstract unsubscribe(
    unsubscribeData: SelfCheckout.PreparedUnsubscribeFormPayload,
  ): ResultStream.ResultStream<void, SelfCheckout.SelfCheckoutError>;
}
